import React from 'react';
import clsx from 'clsx';
import styles from './Input.module.scss';

interface Props {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: 'text' | 'number' | 'email';
  name?: string;
  error?: string;
  className?: string;
  variant?: 'default' | 'grey' | 'thin' | 'edit';
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
}

export function Input({
  label,
  value,
  onChange,
  onBlur,
  type = 'text',
  name,
  error,
  className,
  variant = 'default',
  onKeyDown,
  autoFocus = false
}: Props) {
  const hasValue = value !== '';

  return (
    <div className={clsx(styles.field, className)}>
      <div
        className={clsx(styles.wrapper, {
          [styles.wrapperError]: !!error,
          [styles.wrapperGrey]: variant === 'grey',
          [styles.wrapperThin]: variant === 'thin',
          [styles.wrapperEdit]: variant === 'edit'
        })}
      >
        <label className={clsx(styles.label, { [styles.labelUp]: hasValue })}>
          {label}
        </label>
        <input
          className={styles.input}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
        />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
